export default __webpack_public_path__ + "static/media/instagram-icon.828dee98.svg";